/**
 * Produtos mais vendidos no período (por receita), a partir dos itens dos pedidos que valem venda.
 * Responde "o que está saindo", que o total de pedidos sozinho não diz.
 */
import { createElement as h, type ReactElement } from "react";
import { formatBrl, formatCount } from "../format.js";
import { topProducts } from "../orders/products.js";
import type { PlatformUnifiedOrder } from "../api/types.js";
import { Card, CardHeader, EmptyState } from "../ui/index.js";

export function TopProductsPanel({ orders, limit = 8 }: { orders: PlatformUnifiedOrder[]; limit?: number }): ReactElement {
  const rows = topProducts(orders, limit);
  return h(
    Card,
    { "data-panel": "produtos-mais-vendidos" },
    h(CardHeader, { title: "Produtos mais vendidos", description: "Por receita, entre os pedidos que valem venda no período." }),
    rows.length === 0
      ? h(EmptyState, { title: "Nenhum item vendido neste período" })
      : h(
          "ol",
          { className: "m-0 flex list-none flex-col divide-y divide-border p-0" },
          rows.map((row, index) =>
            h(
              "li",
              { key: row.key, className: "flex items-center justify-between gap-3 py-2 text-sm", "data-product": row.key },
              h("span", { className: "flex min-w-0 flex-col" },
                h("span", { className: "truncate font-semibold text-ink" }, `${index + 1}. ${row.name}`),
                row.sku ? h("span", { className: "text-xs text-muted" }, `SKU ${row.sku}`) : null
              ),
              h("span", { className: "shrink-0 text-muted tabular-nums" }, `${formatCount(row.quantity)} un. · ${formatCount(row.orders)} pedido(s)`),
              h("span", { className: "shrink-0 font-bold tabular-nums text-ink" }, formatBrl(row.revenueCents))
            )
          )
        )
  );
}
